import { render, staticRenderFns } from "./setEmailPage.vue?vue&type=template&id=3833afb2&scoped=true&"
import script from "./setEmailPage.vue?vue&type=script&lang=js&"
export * from "./setEmailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3833afb2",
  null
  
)

export default component.exports